import { render } from "./GoodsListCate2.vue?vue&type=template&id=6ea3d256"
import script from "./GoodsListCate2.vue?vue&type=script&lang=js"
export * from "./GoodsListCate2.vue?vue&type=script&lang=js"

import "./GoodsListCate2.vue?vue&type=style&index=0&id=6ea3d256&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__